import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL?.trim();
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  const missingVars = [
    !SUPABASE_URL && 'REACT_APP_SUPABASE_URL',
    !SUPABASE_ANON_KEY && 'REACT_APP_SUPABASE_ANON_KEY',
  ].filter(Boolean);

  throw new Error(
    `[supabase] Variables manquantes: ${missingVars.join(', ')}. ` +
    'Ajoute-les dans le fichier .env du dossier dashboard/.'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
